import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalCommand.PaymentMethodSelection'

export default defineMessages({
  submitButton: {
    id: `${scope}.submitButton`,
    defaultMessage: 'Use this payment method',
  },
})
